import { api } from '@shared/services/api';
import { useQuery } from '@tanstack/react-query';
import { url } from 'constants/urls';
import { GuildOffersResponse } from 'interface/guildOffersInterface';

export const useGuildOverview = () => {
  const guildOverview = async () => {
    const { data } = await api.get(url.guildOverview);
    return data;
  };

  return useQuery({
    queryKey: ['guildOverview'],
    queryFn: guildOverview,
    refetchOnWindowFocus: false,
  });
};

export const useGuildOffers = () => {
  const guildOffers = async (): Promise<GuildOffersResponse> => {
    const { data } = await api.get(url.guildOffers);
    return data;
  };

  return useQuery({
    queryKey: ['guildOffers'],
    queryFn: guildOffers,
    refetchOnWindowFocus: false,
  });
};
